import { memo } from "react";

import { FieldArray } from "formik";
import withT from "neetocommons/react-utils/withT";
import { Plus } from "neetoicons";
import { Button, Typography } from "neetoui";

import AllowedIpRange from "./AllowedIpRange";

import { NEW_ALLOWED_IP_RANGE } from "../constants";

const AllowedIpRanges = withT(({ t }) => (
  <div
    className="flex flex-col gap-y-5"
    data-testid="allowed-ip-range-container"
  >
    <Typography data-testid="allowed-ip-range-heading" style="h4">
      {t("neetoMolecules.ipRestriction.allowedIpRangeTitle")}
    </Typography>
    <div className="flex flex-col gap-y-3">
      <div className="hidden gap-3 md:flex">
        <div className="grid flex-grow grid-cols-3 gap-3">
          <Typography className="neeto-ui-text-gray-700 uppercase" style="h6">
            {t("neetoMolecules.ipRestriction.ipStart")}*
          </Typography>
          <Typography className="neeto-ui-text-gray-700 uppercase" style="h6">
            {t("neetoMolecules.ipRestriction.ipEnd")}*
          </Typography>
          <Typography className="neeto-ui-text-gray-700 uppercase" style="h6">
            {t("neetoMolecules.ipRestriction.type")}*
          </Typography>
        </div>
        <div className="min-w-14 flex-shrink-0">
          <Typography
            className="neeto-ui-text-gray-700 text-center uppercase"
            style="h6"
          >
            {t("neetoMolecules.ipRestriction.actions")}
          </Typography>
        </div>
      </div>
      <div className="flex w-full flex-col gap-y-6 md:gap-y-4">
        <FieldArray name="allowedIpRanges">
          {arrayHelpers => (
            <>
              {arrayHelpers.form.values.allowedIpRanges.map(
                (allowedIpRange, index) => (
                  <div
                    className="neeto-ui-border-gray-300 w-full border-b pb-6 last:border-none last:pb-0 md:border-none md:pb-0"
                    key={index}
                  >
                    <AllowedIpRange
                      {...{ allowedIpRange, arrayHelpers, index }}
                      key={allowedIpRange.createdAt}
                    />
                  </div>
                )
              )}
              <Button
                className="md:mt-2"
                data-testid="add-allowed-ip-range-button"
                icon={Plus}
                iconPosition="left"
                label={t("neetoMolecules.ipRestriction.addNew")}
                style="link"
                onClick={() => arrayHelpers.push(NEW_ALLOWED_IP_RANGE)}
              />
            </>
          )}
        </FieldArray>
      </div>
    </div>
  </div>
));

export default memo(AllowedIpRanges);
